import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminLanguagesRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/languages',
}).lazy(() => import('./AdminLanguagesRoute.lazy').then((d) => d.Route));
